module.exports = __webpack_public_path__ + "img/materials_education_2.4ad8a3c4.png";